import { render, staticRenderFns } from "./payment-history-icon-box.vue?vue&type=template&id=8d4a73be&scoped=true"
import script from "./payment-history-icon-box.vue?vue&type=script&lang=js"
export * from "./payment-history-icon-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4a73be",
  null
  
)

export default component.exports